import React, { useRef, 
	useEffect,
	useState 
} from "react";
import { connect } from "react-redux";


//import LayerList from "@arcgis/core/widgets/LayerList";
//import { layerCompilation } from "./Layers/allLayersJson";
import { CalciteFlow, CalcitePanel, 
	CalciteButton,
	CalciteAction,
	CalcitePickList,
	//CalcitePickListGroup,
	CalcitePickListItem,
	//CalcitePopoverManager,
	//CalcitePopover,
	//CalcitePopoverManager,
	//CalcitePopover
	CalciteRadioGroup, CalciteRadioGroupItem
} from "@esri/calcite-components-react";
import {loadLayer, removeLayer} from '../../../../Flux/thunks';
import { updateTip } from "../../../../Flux/actions";

const MapLayersPanel = ({availableLayers, onUpdateTip, loadLayerOnMap, removeLayerFromMap, isMapLoading, arcgisMap}) => {
	//console.log('MAP LAYERS: ', layerCompilation, availableLayers);
	const mapLayersDiv = useRef(null);
	
	const [panels, UpdatePanels] = useState([]);

	useEffect(() => {
		
	}, [panels]);
	

	useEffect(() => {
		//console.log(arcgisMap, isMapLoading);
		
	  	if (mapLayersDiv.current && arcgisMap.map) {
			  
		}
	}, [arcgisMap]);
	
	
	const ClearAllPanels = () => {
		console.log('[MapLayersPanel] Clearing all panels')
		UpdatePanels([]);
	}

/*
Layer item: 

*/
	const AddLayerToMap = (layerItem, _event) => {
		//console.log('[MapLayersFlowPanel] DUMB: Adding layer to map.', layerItem);
		if( layerItem.containsSublayers ) {
			//If this is the main item, then pass layerItem.item
			console.log('This item has a sublayer option, lets load', layerItem);

			let findKey = [];
			Object.keys( layerItem.containsSublayers.values ).forEach( ( myValueKey) => {
				findKey.push(layerItem.containsSublayers.values[myValueKey]);

			});
			const myKey = findKey.join('-');

			layerItem.containsSublayers.sublayerLayers.forEach( (sublayerLayerItem) => {
				if( 
					sublayerLayerItem.key
					&& sublayerLayerItem.key === myKey
				){
					loadLayerOnMap(sublayerLayerItem.item);
				}
			})

			/*


			if( layerItem.containsSublayers.main 
				&& layerItem.containsSublayers.main.key
				&& layerItem.containsSublayers.main.key === layerItem.containsSublayers.useSublayer ) {
				loadLayerOnMap(layerItem.item);
			}else{
				//find the sublayer
				layerItem.containsSublayers.sublayerItems.forEach( (sublayerLayerItem) => {
					if( 
						sublayerLayerItem.key
						&& sublayerLayerItem.key === layerItem.containsSublayers.useSublayer
					){
						loadLayerOnMap(sublayerLayerItem.item);
					}
				})
			}
			*/
		}else{
			loadLayerOnMap(layerItem.item);
		}
		//loadLayerOnMap
	};

	const RemoveServicePanel = (event) => {
		//console.log('Removing Panel: ', event);
		event.stopPropagation();
		UpdatePanels( panels.slice(0,-1) );
	}
	const GoToMenu = (_e) => {
		//console.log('EVENT TEST BUTTON', _e);
		UpdatePanels( [...panels, 
			{key: _e.target.value, title: _e.target.title, items: _e.target.items, description: _e.target.groupDescription}] 
			
			);
	}


	const CreateMenuSystem = (currentSelection, title="", mainKey=null, description=null) => {
		console.log('Creating Menu System with the following items: ', {
			currentSelection, title, mainKey, description
		});

		return (
			<CalcitePanel
			key={mainKey || 'head'}
				heading={title === '' ? 'Main Menu' : title}
				summary={description} /* summary is deprecated for some reason, but it currently still 	works */
				onCalcitePanelBackClick={(e)=>{RemoveServicePanel(e);}}
			>
				<CalcitePickList>
				{currentSelection.filter( (selectionItem)=>{
					return selectionItem.hideInMenu !== true;
				}).map( (selectionItem, key) => {
					if( selectionItem.type === 'group' ) {

						//SPECIAL CONDITION, 'custom' and no items
						if( selectionItem.id === 'custom' && selectionItem.items.length < 1 ) {
							return null;
						}


						return (

						<CalcitePickListItem key={key} 
							heading={selectionItem.title} 
							description={selectionItem.title} 
							onCalciteListItemChange={ (_e) => { 
								if( _e.detail && _e.detail.selected) {
									//SearchServer(_e.detail.value);
									GoToMenu(_e);
									_e.target.selected=false;
								}
							}}
							title={selectionItem.title}
							groupDescription={selectionItem.description}
							items={selectionItem.items}
							>
							<CalciteAction slot="actions-end" icon="chevrons-right" 
								title={selectionItem.title}
								items={selectionItem.items}
								groupDescription={selectionItem.description}
								onClick={ (_e) => { GoToMenu(_e) }}></CalciteAction>
						</CalcitePickListItem>


						);
					}else if( selectionItem.type === 'layer') {
						const appendHelper = {};
						if( !selectionItem.meta ) {
							appendHelper.disabled=true;
						}

						console.log('[MapLayersPanel] This specific item: ', selectionItem);
						return (
							<>
							<CalcitePickListItem key={key} 
							heading={selectionItem.item.title} 
							description={selectionItem.item.title} 
							title={selectionItem.item.title} 

							value={selectionItem.item} 
							onCalciteListItemChange={ (_e) => { 
								if( _e.detail && _e.detail.selected) {
									//SearchServer(_e.detail.value);
									//AddLayerToMap()
								}
							}}
							>
							<CalciteAction 
								slot="actions-end"
								icon="information" 
								title="Metadata"
								{...appendHelper}
								onClick={ (_e) => { console.log('Activating Metadata...', _e); 
									if(selectionItem.meta ) {
										const {layerTitle, layerDescription, mapService, authoritiveSource} = selectionItem.meta;
										onUpdateTip(layerTitle, layerDescription, mapService, authoritiveSource);
									}
								}}></CalciteAction>
								{
									selectionItem.containsSublayers ? 
									<CalciteAction slot="actions-end" icon="sliders" onClick={ (_e) => { 
										 document.getElementById(`${selectionItem.layerId}-sublayerOptions`)?.classList.toggle('hide-options')
									}}></CalciteAction>
									: null
								}
								
							<CalciteAction slot="actions-end" icon={
								selectionItem.type === 'tiles' ? 'tile-layer' : 'add-layer'
							 } onClick={ (_e) => { 
								 console.log(selectionItem);
								//SearchServer(layers.url); 
								AddLayerToMap(selectionItem);
							}}></CalciteAction>
							{
								console.log('[MapLayersPanel] SUBLAYERS: ',selectionItem.containsSublayers)
							}
							{
								console.log('[MapLayersPanel] TITLE: ',selectionItem.item.title)
							}
							</CalcitePickListItem>
							{
								selectionItem.containsSublayers ? 
								
								<div id={`${selectionItem.layerId}-sublayerOptions`} 
									className="content-area layer-options hide-options">
									{
										selectionItem.containsSublayers.filters.map( (filterItems) => {

											return (<>
												<h3>{filterItems.groupLabel || 'No Group Label'}</h3>
												<CalciteRadioGroup
													value={selectionItem.containsSublayers.values[filterItems.filterKey]}
													onCalciteRadioGroupChange={(e)=>{
														console.log('[MapLayersPanel] Switched Sublayer Option: ', e);
														console.log('[MapLayersPanel]',`Title: ${selectionItem.item.title}`, 'Current values: ', selectionItem.containsSublayers.values);

														if( e.detail ) {
															selectionItem.containsSublayers.values[filterItems.filterKey]=e.detail;
														}

														console.log('[MapLayersPanel] Set to values: ', selectionItem.containsSublayers.values);
													}}
														width="full" layout="vertical"
												>
													{filterItems.options.map( (filterOptions) => {
														/*
														console.log('[MapLayersPanel]', {
															sublayers: selectionItem.containsSublayers,
															filterItems,
															filterOptions,
															//filterKey: filterItems.filterKey,
															//selectedKey: filterOptions.key
														});
														*/

														console.log('[MapLayersPanel]','Current options vs item options',{
															currentSelection: selectionItem.containsSublayers.values,
															currentValue: selectionItem.containsSublayers.values[filterItems.filterKey],
															thisKey: filterItems.filterKey,
															thisValue: filterOptions.key,
															shouldBeChecked: {
																value1:selectionItem.containsSublayers.values[filterItems.filterKey],
																value2:filterOptions.key,
																checked: selectionItem.containsSublayers.values[filterItems.filterKey] === filterOptions.key ? true : null
															}
														});

														if( selectionItem.containsSublayers.values[filterItems.filterKey] === filterOptions.key ) {
															return <CalciteRadioGroupItem 
															filterKey={filterItems.filterKey}
															valueObj={{key:filterItems.filterKey, value: filterOptions.key} } 
															checked={true}
															value={`${filterOptions.key}`}
															>{filterOptions.label}</CalciteRadioGroupItem>
														}
														
														return <CalciteRadioGroupItem 
														filterKey={filterItems.filterKey}
														valueObj={{key:filterItems.filterKey, value: filterOptions.key} } 
														value={`${filterOptions.key}`}
														>{filterOptions.label}</CalciteRadioGroupItem>

													})}

												</CalciteRadioGroup>
											</>);
										})
									}
									</div>
								:null

							}
							</>
						);
					}
					return null;

				})}
				</CalcitePickList>
			</CalcitePanel>
		);

	}

	return (
		<>
			<div className="content-area">
			<CalciteButton
				width={"full"}
				onClick={(_e) => { 
					ClearAllPanels();
				}}
				iconStart="reset"
			>
				Go to Main Menu
			</CalciteButton>
			</div>
			<CalciteFlow>
				{CreateMenuSystem(availableLayers)}
				{panels.map( (panelItem, key)=> {
					return CreateMenuSystem(panelItem.items, panelItem.title, key, panelItem.description);
				})}
			</CalciteFlow>
		</>
	);
}

const mapStateToProps = (state) => ({
    availableLayers: state.availableLayers,
});
// what actions are we allowed to use
const mapDispatchToProps = (dispatch) => ({
	onUpdateTip: (layerTitle, layerDescription, mapService, authoritiveSource) => {dispatch(updateTip(layerTitle, layerDescription, mapService, authoritiveSource))},
	loadLayerOnMap: (layer) => {dispatch(loadLayer(layer))},
	removeLayerFromMap: (layer) => {dispatch(removeLayer(layer))}
});

export default connect(mapStateToProps, mapDispatchToProps)(MapLayersPanel);
